import { createSelector } from '@reduxjs/toolkit';
import { selectLocationIdForMetroMap } from '../geo';

const availableMetroScheme: number[] = require('@cian/metro/ready');

export const selectHasUnderground = createSelector(selectLocationIdForMetroMap, locationId =>
  availableMetroScheme.some(id => id === locationId),
);
